import React, { useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import { Alert, Autocomplete, Box, IconButton, Paper, Table, TableBody, TableContainer, TableHead, TablePagination, TableRow, TextField } from '@mui/material';
import { useNavigate, Route, Routes } from 'react-router-dom';

import { StyledTableCell, StyledTableRow, useStyles } from './styles';

import { useRecoilValue, useSetRecoilState } from 'recoil';
import JobInfo from './info';
import { clientsSelector, filtersSelectorFamily, jobDataState, jobsState, pageInfoSelector } from './states';

const renderClientInput = (params) => <TextField {...params} label="Select client" variant="outlined" />;

export default function JobList() {
  const navigate = useNavigate();

  const { classes } = useStyles();
  const [message, setMessage] = useState(null);
  const jobs = useRecoilValue(jobsState);
  const setJobData = useSetRecoilState(jobDataState);
  const clients = useRecoilValue(clientsSelector);

  const setClientId = useSetRecoilState(filtersSelectorFamily('client_id'));
  const setPage = useSetRecoilState(filtersSelectorFamily('page'));
  const setSize = useSetRecoilState(filtersSelectorFamily('size'));

  const pageInfo = useRecoilValue(pageInfoSelector);

  const gotoDelete = (job) => () => {
    navigate(`/jobs/${job.id}`);
  };

  return (
    <Box sx={{ p: 3 }}>
      {message && <Alert severity="success">{message}</Alert>}

      <Paper elevation={0} component="form" className={classes.search}>
        {clients && clients.length > 0 && (
          <Autocomplete
            id="clients"
            options={clients}
            onChange={(e, v) => {
              v ? setClientId(v.id) : setClientId(undefined);
            }}
            getOptionLabel={(option) => option.company}
            style={{ width: 300 }}
            renderInput={renderClientInput}
          />
        )}
      </Paper>

      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>ID</StyledTableCell>
              <StyledTableCell>Client</StyledTableCell>
              <StyledTableCell>Name</StyledTableCell>
              <StyledTableCell>Start Date</StyledTableCell>
              <StyledTableCell>End Date</StyledTableCell>
              <StyledTableCell>Shipment Count</StyledTableCell>
              <StyledTableCell>Status</StyledTableCell>
              <StyledTableCell>Action</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {jobs &&
              jobs.length > 0 &&
              jobs.map((job) => (
                <StyledTableRow key={job.id}>
                  <StyledTableCell component="th" scope="row">
                    {job.id}
                  </StyledTableCell>
                  <StyledTableCell>{job.client_name}</StyledTableCell>
                  <StyledTableCell>{job.name}</StyledTableCell>
                  <StyledTableCell>{job.dropoff_earliest_ts}</StyledTableCell>
                  <StyledTableCell>{job.dropoff_latest_ts}</StyledTableCell>
                  <StyledTableCell>{job.shipment_count}</StyledTableCell>
                  <StyledTableCell>{job.status}</StyledTableCell>
                  <StyledTableCell>
                    <IconButton onClick={gotoDelete(job)} aria-label="delete" size="large">
                      <DeleteIcon />
                    </IconButton>
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            {(!jobs || jobs.length <= 0) && (
              <StyledTableRow>
                <StyledTableCell align="center" colSpan={8}>
                  No jobs!
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {pageInfo && (
        <TablePagination
          rowsPerPageOptions={[5, 10, 20, 30, 40, 50, 100]}
          component="div"
          count={pageInfo.total ? pageInfo.total : 0}
          rowsPerPage={pageInfo.size ? pageInfo.size : 0}
          page={pageInfo.page ? pageInfo.page : 0}
          onPageChange={(event, newPage) => {
            setPage(newPage);
          }}
          onRowsPerPageChange={(event) => {
            setSize(parseInt(event.target.value, 10));
          }}
        />
      )}
      <Routes>
        <Route path=":id" element={<JobInfo />} />
      </Routes>
    </Box>
  );
}
